import {
  TConfigBaseUrl,
  TConfigBaseUrlServer,
  TConfigEmail,
  TConfigEmailServer,
  TConfigTelegram,
  TConfigTelegramChatRouting,
  TConfigTelegramChatRoutingServer,
  TConfigTelegramServer,
} from '../../store/types';

export const configBaseUrlAdapter = (item: TConfigBaseUrlServer): TConfigBaseUrl => ({
  baseUrl: item.base_url,
});

export const configEmailAdapter = (item: TConfigEmailServer): TConfigEmail => ({
  smtpAddress: item.smtp_address,
  smtpPort: item.smtp_port,
  login: item.login,
  password: item.password,
  emailProxyUrl: item.email_proxy_url,
});

export const configTelegramAdapter = (item: TConfigTelegramServer): TConfigTelegram => ({
  botToken: item.bot_token,
  depositsChatId: item.deposits_chat_id,
  withdrawalsChatId: item.withdrawals_chat_id,
});

export const configTelegramChatRoutingAdapter = (
  item: TConfigTelegramChatRoutingServer,
): TConfigTelegramChatRouting => ({
  enabled: item.enabled,
  operators: item.operator_usernames.map((username) => `@${username}`).join(' '),
  relayChats: (item.relay_chats || []).map((chat) => ({
    name: chat.name,
    chatId: String(chat.chat_id),
    destinationChatId: String(chat.destination_chat_id),
    confirmationReaction: chat.confirmation_reaction,
    confirmationAlternateReaction: chat.confirmation_alternate_reaction ?? '',
    confirmationThirdReaction: chat.confirmation_third_reaction ?? '',
    confirmationCustomEmojiId: chat.confirmation_custom_emoji_id ?? '',
    reminderUsernames: (chat.reminder_usernames ?? []).map((username) => `@${username}`).join(' '),
    confirmationText: chat.confirmation_text,
    successMessage: chat.success_message,
  })),
  clientChats: item.client_chats.map((clientChat) => ({
    name: clientChat.name,
    chatId: String(clientChat.chat_id),
    shopIds: clientChat.shop_ids.map(String),
    routes: clientChat.routes.map((route) => ({
      paymentSystem: route.payment_system,
      chatId: String(route.chat_id),
    })),
    lookupFields: clientChat.lookup_fields,
    missingReferenceMessage: clientChat.missing_reference_message,
    unresolvedMessage: clientChat.unresolved_message,
    successMessage: clientChat.success_message,
  })),
});
